import Vue from "vue"
import Vuex from "vuex"
import app from "./modules/app"
import pilot from "./modules/pilot"
import question from "./modules/question"
import answers from "./modules/answers"
import grid from "./modules/grid"
import labels from "./modules/labels"
import offline from "./modules/offline"
import live from "./modules/live"
import socket from "./modules/socket"
import socketppt from "./modules/socketppt"
import undo from "./modules/undo"
import createLogger from "../plugins/logger"

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== "production"
const debug = true

export default new Vuex.Store({
  modules: {
    app,
    pilot,
    question,
    answers,
    grid,
    labels,
    offline,
    live,
    socket,
    socketppt,
    undo,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
})
